import {AbstractParameter} from './AbstractParameter.js';

class MidiCCParameter extends AbstractParameter {
    constructor(name, ccNumber, midiCC) {
        let initial = true;
        super(
            name,
            midiCC,
            (obj, value) => {
                if (!initial) {
                    obj.send(ccNumber, value);
                }
                initial = false;
            },
            {
                min: 0,
                max: 127,
                defaultValue: 1,
            },
        );

        this.ccNumber = ccNumber;

        midiCC.setCallback(
            ccNumber,
            (value) => {
                this.set(value);
            });
    }

    getJson() {
        let json = super.getJson();
        json.ccNumber = this.ccNumber;
        return json;
    }
}

export default MidiCCParameter;
